import React, { useEffect, useRef } from 'react';
import type { BoardSummary, BrowserKind } from './accountState';
import type { DismissTelemetry } from './captureTiming';
import { isInAppBrowser } from '../lib/inAppBrowser';
import { V4SignInModal } from './V4SignInModal';
import type { V4AuthAccount } from '../auth/v4Auth';

/** The board reminder uses the same login form as every account entry point. */
export interface V4CaptureSheetProps {
  open: boolean;
  boards: BoardSummary[];
  browser?: BrowserKind;
  onDismiss: (telemetry: DismissTelemetry) => void;
  /** Firebase's verdict, not the in-sheet mode toggle — see `V4SignInModalProps.onSignedIn`. */
  onSignedIn?: (account: V4AuthAccount) => void;
  now?: () => number;
}

export const V4CaptureSheet: React.FC<V4CaptureSheetProps> = ({
  open, boards, browser = isInAppBrowser() ? 'webview' : 'normal',
  onDismiss, onSignedIn, now = Date.now,
}) => {
  const openedAt = useRef(now());
  useEffect(() => { if (open) openedAt.current = now(); }, [open, now]);
  return <V4SignInModal
    open={open}
    browser={browser}
    boards={boards}
    boardCount={boards.length}
    testId="v4-capture-sheet"
    fromCaptureSheet
    onClose={() => undefined}
    onSignedIn={onSignedIn}
    onDismiss={(reason) => onDismiss({
      reason, secondsOnScreen: Math.max(0, Math.round((now() - openedAt.current) / 1000)),
    })}
  />;
};

export default V4CaptureSheet;
